import { render, staticRenderFns } from "./GameShop.vue?vue&type=template&id=3af0a3be"
import script from "./GameShop.vue?vue&type=script&lang=js"
export * from "./GameShop.vue?vue&type=script&lang=js"
import style0 from "./GameShop.vue?vue&type=style&index=0&id=3af0a3be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports